export interface FindParams {
  page?: number;
  per_page?: number;
  order?: string;
  order_direction?: string;
  expand?: string;
  'expand[]'?: string[];
  'id[]'?: string[];
  id?: string;
  inactive?: boolean;
  // RP-4301: `true` skips the API's COUNT(*) — the response then carries no Total-Count header.
  countless?: boolean;
}
